/**
 * Dependencies.
 */
import { BaseModel, endpoint } from '@prz-dp/services';

/**
 * Model `DocumentModel`.
 */
@endpoint('document')
export default class DocumentModel extends BaseModel {
  /**
   * Properties.
   */
  encodedFileContent: string;

  fileName: string;

  mediaType: string;

  /**
   * Constructor.
   */
  constructor(data: Partial<DocumentModel>) {
    super(data);
  }
}
